// Defaults for new cloud-authored configuration; never replace a saved/reported value.
export const DEFAULT_NTP_SERVER = "ng.pool.ntp.org";
